const BASE_URL = process.env.REACT_APP_BASE_URL;
// const BASE_URL = 'http://localhost:3000/api';

export const API_URLS = {
  // Authentication
  LOGIN_ADMIN: `${BASE_URL}/admin/auth/login`,
  UPDATE_PASSWORD: `${BASE_URL}/admin/auth/resetPassword`,

  // VERIFIED
  UPDATE_STATUS_EMAIL: `${BASE_URL}/admin/authority/updateComplaintStatusFromMail`,

  // DASHBOARD ACTION BY PMU COUNT
  GET_ACTION_BY_PMU_COMPLAINTS: `${BASE_URL}/admin/complaint/actionbypmucomplaints?limit=10&page=1`,

  // DASHBOARD GRAPH API
  GET_SECTOR_COUNTS: `${BASE_URL}/admin/complaint/getcomplaintscountbysector`,
  GET_SUB_SECTOR_COUNTS: `${BASE_URL}/admin/complaint/getcomplaintscountbysubsector`,
  GET_STATE_COUNTS: `${BASE_URL}/admin/complaint/getcomplaintscountbystate`,

  // USER MASTER
  GET_USER_MASTER: `${BASE_URL}/admin/user/getadminusers`,
  ADD_USER_MASTER: `${BASE_URL}/admin/user/createadminuser`,
  DELETE_USER_MASTER: `${BASE_URL}/admin/user/deleteadminuser`,
  DEPARTMENT_MASTER_DROPDOWN: `${BASE_URL}/admin/user/populatedepartmentdropdown`,
  DESIGNATION_MASTER_DROPDOWN: `${BASE_URL}/admin/user/populatedesignationdropdown`,
  GET_STATE_NAMES: `${BASE_URL}/admin/user/getstate`,
  GET_DISTRICT_NAMES: `${BASE_URL}/admin/user/getdistrict`,
  GET_USER_BY_ID: `${BASE_URL}/admin/user/getAdminUser`,
  UPDATE_USER_MASTER: `${BASE_URL}/admin/user/updateAdminUser`,
  GET_DC_LIST_FOR_SC: `${BASE_URL}/admin/user/getDistrictCollectorsListForStateCommissinor`,
  GET_DC_LIST_FOR_ADMIN: `${BASE_URL}/admin/user/getDistrictCollectorsListForAdmin`,
  PENDING_USER_STATUS_CHANGE: `${BASE_URL}/admin/user/updateDistrictCollectStatusByIdForAdmin`,
  GET_DePWD_USERS: `${BASE_URL}/admin/complaint/getDePWDUsers`,
  GET_SCPD_USERS: `${BASE_URL}/admin/complaint/getSCPDUsers`,
  GET_DM_USERS: `${BASE_URL}/admin/complaint/getDMUsers`,
  GET_NODAL_OFFICER_USERS: `${BASE_URL}/admin/complaint/getNodalOfficerUsers`,

  // Complaint Assignment
  GET_COMPLAINT_ASSIGNMENT: `${BASE_URL}/admin/assignment/all`,
  Delete_COMPLAINT_ASSIGNMENT: `${BASE_URL}/admin/assignment/deleteAssignment`,
  UPDATAE_COMPLAINT_ASSIGNMENT: `${BASE_URL}/admin/assignment/getAssignment`,
  SECTORS_COMPLAINT_ASSIGNMENT: `${BASE_URL}/admin/assignment/sectors`,
  GET_ASSIGNMENT_MASTER: `${BASE_URL}/admin/assignment/sectors`,
  POST_ASSIGNMENT_MASTER_ADMINUSER: `${BASE_URL}/admin/assignment/adminUsers`,
  GET_COMPLAINT_DETAIL: `${BASE_URL}/admin/complaint/getComplaintDetail`,
  GET_COMPLAINT_ASSIGNMENT_BY_ID: `${BASE_URL}/admin/assignment/getAssignment`,
  UPDATE_COMPLAINT_ASSIGNMENT: `${BASE_URL}/admin/assignment/updateAssingment`,

  // Complaint View
  GET_COMPLAINTS_VIEW: `${BASE_URL}/admin/complaint/getcomplaintsNew`,
  GET_PMU_STATUS: `${BASE_URL}/admin/complaint/pmuStatusConstants`,
  GET_CA_LIST: `${BASE_URL}/admin/complaint/getCAList`,
  UPDATE_COMPLAINT_VIEW: `${BASE_URL}/admin/complaint/updateComplaintNew`,

  // Complaint View Auhtoirty user
  GET_COMPLAINTS_VIEW_AUTHORITY_USER: `${BASE_URL}/admin/authority/myComplaints`,
  GET_AUTHORITY_STATUS: `${BASE_URL}/admin/complaint/authorityStatusConstants`,
  UPDATE_COMPLAINT_VIEW_AUTHORITY_USER: `${BASE_URL}/admin/authority/updateComplaintStatus`,

  // Complaint View STATE USER
  GET_COMPLAINTS_VIEW_STATE_USER: `${BASE_URL}/admin/stateUser/getComplaintsByState`,

  // Complaint View DISTRICT USER
  GET_COMPLAINTS_VIEW_DISTRICT_USER: `${BASE_URL}/admin/districtUser/getComplaintsByDistrict`,

  // Category Master
  GET_SECTORS: `${BASE_URL}/admin/assignment/sectors`,
  CREATE_COMPLAINT_ASSIGNMENT: `${BASE_URL}/admin/assignment/createAssignment`,

  // Events
  GET_EVENTS: `${BASE_URL}/event/panel`,
  GET_EVENTS_BY_ID: `${BASE_URL}/event`,
  ADD_EVENT: `${BASE_URL}/event`,
  UPDATE_EVENT: `${BASE_URL}/event`,
  DELETE_EVENT: `${BASE_URL}/event`,

  // Resources
  GET_RESOURCES: `${BASE_URL}/resources/getresources`,
  GET_RESOURCE_BY_ID: `${BASE_URL}/resources/getresources`,
  ADD_RESOURCE: `${BASE_URL}/resources/addresources`,
  UPDATE_RESOURCE: `${BASE_URL}/resources/updateresources`,
  DELETE_RESOURCE: `${BASE_URL}/resources/deleteresources`,

  // Helplines
  GET_HELPLINES: `${BASE_URL}/resources/gethelplines`,
  ADD_HELPLINE: `${BASE_URL}/resources/addhelpline`,
  UPDATE_HELPLINE: `${BASE_URL}/resources/updatehelpline`,
  DELETE_HELPLINE: `${BASE_URL}/resources/deletehelpline`,

  // Notifications
  SEND_PUSH_NOTIFICATION: `${BASE_URL}/admin/notification/push`,

  // Information/guidelines(GRA)
  GET_INFORMATION_GRA: `${BASE_URL}/resources/searchgra-panel`,
  ADD_INFORMATION_GRA: `${BASE_URL}/resources/addGRA`,
  EDIT_INFORMATION_GRA: `${BASE_URL}/resources/updategra`,
  DELETE_INFORMATION_GRA: `${BASE_URL}/resources/deletegra`,
  GET_INFORMATION_GRA_BY_ID: `${BASE_URL}/resources/getgrabyid`,
  GET_S3_URL: `${BASE_URL}/resources/get-s3-url`,
  REMOVE_S3_URL: `${BASE_URL}/resources/remove-s3-url`,

  // Opportunities
  GET_OPPORTUNITIES_DATA: `${BASE_URL}/opportunities`,
  ADD_OPPORTUNITIES_DATA: `${BASE_URL}/opportunities`,
  EDIT_OPPORTUNITIES_DATA: `${BASE_URL}/opportunities`,
  DELETE_OPPORTUNITIES_DATA: `${BASE_URL}/opportunities`,

  // User Opportunities
  GET_USER_OPPORTUNITIES: `${BASE_URL}/admin/user-opportunities`,
  APPROVE_USER_OPPORTUNITY: `${BASE_URL}/admin/user-opportunities`,
  REJECT_USER_OPPORTUNITY: `${BASE_URL}/admin/user-opportunities`,

  // Complaint reassignment
  REQUEST_COMPLAINT_REASSIGNMENT: `${BASE_URL}/admin/complaint/requestComplaintReassignment`,

  // Schemes
  GET_SCHEMES_DATA: `${BASE_URL}/resources/searchschemes-panel`,
  GET_SCHEMES_DATA_BY_ID: `${BASE_URL}/resources/get-scheme`,
  ADD_SCHEMES_DATA: `${BASE_URL}/resources/add-scheme`,
  UPDATE_SCHEMES_DATA: `${BASE_URL}/resources/update-scheme`,
  DELETE_SCHEMES_DATA: `${BASE_URL}/resources/delete-scheme`,

  // DepartmentMaster
  GET_DEPT_MASTER_LIST: `${BASE_URL}/admin/user/getDepMaster`,
  GET_DESIGNATION_MASTER_LIST: `${BASE_URL}/admin/user/getDesignationMaster`,

  // Positive Feedback
  GET_FEEDBACK_LIST: `${BASE_URL}/admin/feedback/getfeedbacks`,
  GET_FEEDBACK_DETAIL: `${BASE_URL}/admin/feedback/getfeedbackdetail`,

  // Department Statistics
  ADMIN_COMPLAINT_STATISTICS_ASSIGNED_TO: `${BASE_URL}/admin/complaint/statistics/assignedTo`,
  ADMIN_COMPLAINT_STATISTICS_DEPARTMENT_USER: `${BASE_URL}/admin/complaint/statistics/departmentUser`,
  ADMIN_COMPLAINT_STATISTICS_STATE: `${BASE_URL}/admin/complaint/statistics/state`,
  ADMIN_COMPLAINT_STATISTICS_DISTRICT_FOR_STATE: `${BASE_URL}/admin/complaint/statistics/districtForState`,
  ADMIN_COMPLAINT_STATISTICS_NODAL_OFFICER: `${BASE_URL}/admin/complaint/statistics/nodalOfficerMinistry`,


  // Complaint Reassingment
  ADMIN_GET_COMPLAINT_REASSIGNMENT_REQUESTS: `${BASE_URL}/admin/assignment/reassign-requests`,
  ADMIN_CREATE_COMPLAINT_REASSIGNMENT: `${BASE_URL}/admin/assignment/reassign`,
  ADMIN_ACCEPT_REASSIGNMENT: `${BASE_URL}/admin/assignment/reassign-request`,

  //Site Feedback
  SITE_FEEDBACK_SUBMIT: `${BASE_URL}/feedback/submit-site-feedback`,
};
